import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'toggler']

  connect() {
    this.initialHeight = this.element.clientHeight

    if (this.initialHeight === this.listTarget.clientHeight) {
      this.hideToggler(true)
    }

    window.addEventListener('resize', () => {
      this.hideToggler(this.initialHeight === this.listTarget.clientHeight)
      if (this.element.style.height) this.element.style.height = this.listTarget.clientHeight + 'px !important'
      if (this.initialHeight !== this.element.clientHeight) this.element.style.height = this.listTarget.clientHeight + 'px'
    })
  }

  toggle() {
    if (this.initialHeight === this.element.clientHeight) {
      this.togglerTarget.querySelector('svg').style.transform = 'rotate(180deg)'
      this.togglerTarget.querySelector('span').innerText = 'Moins'
      this.element.style.height = this.listTarget.clientHeight + 'px'
    } else {
      this.togglerTarget.querySelector('svg').style.transform = null
      this.togglerTarget.querySelector('span').innerText = 'Plus'
      this.element.style.height = this.initialHeight + 'px'
    }
  }

  hideToggler(bool) {
    if (bool) {
      this.togglerTarget.classList.add('opacity-0')
    } else {
      this.togglerTarget.classList.remove('opacity-0')
    }
  }
}
